<aside class="sigma_aside sigma_aside-right sigma_aside-right-panel sigma_aside-bg"
    [ngClass]="canvasMethod ? 'open':''">
    <app-canvas></app-canvas>
</aside>
<div class="sigma_aside-overlay aside-trigger-right" (click)="toggleCanvas()"></div>
<aside class="sigma_aside sigma_aside-left" [ngClass]="navMethod ? 'open':''">
    <app-mobile-menu></app-mobile-menu>
</aside>
<div class="sigma_aside-overlay aside-trigger-left" (click)="toggleNav()"></div>
<header class="sigma_header header-3 can-sticky header-absolute">
    <div class="sigma_header-middle">
        <nav class="navbar">
            <div class="sigma_logo-wrapper">
                <a routerLink="/" class="navbar-brand logo-container">
                    <img src="assets/img/logo.png" alt="logo-container_image">
                    <div class="d-flex logo-container_name">
                        <span>{{'father' | translate}}</span>
                        <span>{{'bishoy' | translate}}</span>
                        <span>{{'kamel' | translate}}</span>
                    </div>
                </a>
            </div>
            <div class="sigma_header-inner">
                <div class="sigma_header-top">
                    <div class="sigma_header-top-inner">
                        <ul class="sigma_header-top-links">
                            <li class="menu-item"> <a href="mailto:admin@frbishoykamel.org"> <i class="fal fa-envelope"></i>admin@frbishoykamel.org</a> </li>
                        </ul>
                        <ul class="sigma_header-top-links">
                            <li class="menu-item menu-item-has-children d-flex align-items-center">
                                <img *ngIf="_translatesService.getCurrentLang() == 'en'; else ar" src="assets/img/en.png" alt="img">
                                <ng-template #ar>
                                    <img src="assets/img/ar.png" alt="img">
                                </ng-template>
                                <a class="m-0 language-dd"> {{'language' | translate}}</a>
                                <ul class="sub-menu sub-menu-left">
                                    <li> <a (click)="changeLanguage('en')">{{'en' | translate}}</a>  </li>
                                    <li> <a (click)="changeLanguage('ar')">{{'ar' | translate}}</a>  </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="d-flex justify-content-center justify-content-lg-between">
                    <ul class="navbar-nav">
                        <li [ngClass]="item.child ? 'menu-item menu-item-has-children':'menu-item'"
                        *ngFor="let item of navigation">
                        <a
                          [ngClass]="isActive(item) ? 'active-tab' : ''"
                          [routerLink]="item.link"
                          [queryParams]="getQueryParams(item)"
                          *ngIf="item.child"
                        >
                          {{ item.isType ? item.linkText : (item.linkText | translate) }}
                        </a>

                        <a
                          [ngClass]="isActive(item) ? 'active-tab' : ''"
                          [routerLink]="item.link"
                          [queryParams]="getQueryParams(item)"
                          *ngIf="!item.child"
                        >
                          {{ item.isType ? item.linkText : (item.linkText | translate) }}
                        </a>
                        <ul class="sub-menu" *ngIf="item.child">
                            <li [ngClass]="item.child ? 'menu-item menu-item-has-children':'menu-item'"
                                *ngFor="let item of item.submenu">
                                <a routerLink="{{item.link}}" [queryParams]="getQueryParams(item)" *ngIf="item.child">{{item.linkText | translate}}</a>
                                <a routerLink="{{item.link}}" [queryParams]="getQueryParams(item)" *ngIf="!item.child">{{item.linkText | translate}}</a>
                                <ul class="sub-menu" *ngIf="item.child">
                                    <li [ngClass]="item.child ? 'menu-item menu-item-has-children':'menu-item'"
                                        *ngFor="let item of item.submenu">
                                        <a routerLink="{{item.link}}">{{item.linkText | translate}}</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="sigma_header-controls style-2 d-none">
                <ul class="sigma_header-controls-inner">
                    <!-- Mobile Toggler -->
                    <li class="aside-toggler style-2 aside-trigger-left" (click)="toggleNav()">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</header>
